import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isTokenExpired } from 'lib/auth/authUtils';

const ProtectedRoute = () => {
  const location = useLocation();

  if (isTokenExpired()) {
    return <Navigate to="/login?expired=true" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
